export const trackUnsubscribe = () => ({
    event: 'opt_in',
    opt_position: 'optout page',
    opt_value: false,
})
